export default __webpack_public_path__ + "static/media/ausdt.f5feda46.svg";